import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
})
export class ClickOutsideDirective {
  @Output() clickOutside = new EventEmitter<void>();
  private firstTime = false;

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target']) public onClick(target) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside && this.firstTime) {
      this.clickOutside.emit();
    }
    this.firstTime = true;
  }
}
